import { useEffect, useState } from "react";
import { Mail, Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge } from "./ui";

export default function Leads() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leads").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader eyebrow="INBOX" title="Contact Requests" subtitle="Messages from the contact form on your marketing site" />
      <div className="p-8">
        {rows.length === 0 ? (
          <p className="text-sm text-muted-foreground">No messages yet.</p>
        ) : (
          <div className="card-elevated rounded-sm overflow-hidden" data-testid="leads-table">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border text-left font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Company</th>
                  <th className="px-4 py-3">Email</th>
                  <th className="px-4 py-3">Message</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Received</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((l) => (
                  <tr key={l.id} className="border-b border-border last:border-0 hover:bg-white/[0.02] transition-colors">
                    <td className="px-4 py-3">{l.name}</td>
                    <td className="px-4 py-3"><span className="flex items-center gap-2"><Building2 className="h-3.5 w-3.5 text-muted-foreground" />{l.company || "—"}</span></td>
                    <td className="px-4 py-3 font-mono text-xs text-muted-foreground"><span className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" />{l.email}</span></td>
                    <td className="px-4 py-3 text-muted-foreground max-w-xs truncate" title={l.message}>{l.message || "—"}</td>
                    <td className="px-4 py-3"><StatusBadge value={l.status} /></td>
                    <td className="px-4 py-3 font-mono text-[10px] text-muted-foreground">{new Date(l.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
